/**
 * Etiquetas de UI (singular/plural) por sujeto de nómina, indexadas por el
 * mismo slug de content_type ('empleado' | 'becario' | 'honorarioasimilado')
 * que ya expone el backend en TipoDeNominaEmpleado.content_type_model.
 */
export const SUJETO_DE_NOMINA_LABELS = {
  empleado: { singular: 'Empleado', plural: 'Empleados' },
  becario: { singular: 'Becario', plural: 'Becarios' },
  honorarioasimilado: { singular: 'Honorario Asimilado', plural: 'Honorarios Asimilados' },
};

/**
 * Regresa las etiquetas del sujeto para el content_type_model dado.
 * Si el tipo de nomina empleado aun no tiene content_type asignado (nominas
 * anteriores a la Fase 1) o el slug no se reconoce, cae a 'Empleado'.
 */
export const getSujetoDeNominaLabels = (contentTypeModel) => (
  SUJETO_DE_NOMINA_LABELS[contentTypeModel] || SUJETO_DE_NOMINA_LABELS.empleado
);
